import { getAggregatedTranslations } from '@/services/ws-translate/src/main/resources/rest-api/index.ts';
import { StatusSchema, unsafeCastToApiError } from '@/js/libs/api/index.ts';
const backendOptions = {
    loadPath: '{{lng}}.{{ns}}',
    request: (options, url, payload, callback) => {
        const [lng, ns = ''] = url.split('.');
        const params = {
            language: lng,
            namespace: ns,
        };
        getAggregatedTranslations({ params })
            .then(({ data }) => {
            const response = {
                status: data.responseCode,
                data: JSON.stringify(data.data[0]?.namespaces?.[0]?.values ?? {}),
            };
            callback(null, response);
        })
            .catch((error) => callback(error, { status: unsafeCastToApiError(error, StatusSchema)?.response?.status || 500, data: '' }));
    },
    reloadInterval: 1000 * 60 * 10,
};
export default backendOptions;
